import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Grid,
  TextField,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { ColDef } from "ag-grid-community";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

import { AgGridReact } from "ag-grid-react";

const PaypalCancellation = () => {
  const [cancellationReason, setCancellationReason] = useState<string>("");
  const [handleStatusTimer, setHandleStatusTimer] = useState<any>(null);
  const [subscriptionId, setSubscriptionId] = useState<string>("");
  const [isCancelDone, setIsCancelDone] = useState<boolean>(false);
  const [isStatusDone, setIsStatusDone] = useState<boolean>(false);
  const [action, setAction] = useState<boolean>(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const agGridRef = useRef<AgGridReact | null>(null);

  useEffect(() => {
    return () => {
      clearTimeout(handleStatusTimer);
    };
  }, []);

  const handlePaypalStatus = async () => {
    toast.dismiss();
    if (subscriptionId.trim() !== "") {
      setRowData([]);
      setIsStatusDone(true);
      paypalStatus();
    } else {
      toast.error("Please enter subscriptionId.");
    }
  };
  const handleCancelPaypal = async () => {
    toast.dismiss();
    cancelPaypal();
    setRowData([]);
    setIsStatusDone(true);
    const handleStatusTimer = setTimeout(() => {
      handlePaypalStatus();
    }, 35000);
    setHandleStatusTimer(handleStatusTimer);
  };

  const paypalStatus = async () => {
    await axiosInterceptorInstance
      .get(`/dashboard/PaypalStatus?SubscriptionId=${subscriptionId.trim()}`)
      .then((res: any) => {
        setIsStatusDone(false);
        const responseData = JSON.parse(res.data.body);

        if (responseData?.data != null) {
          setRowData([responseData.data]);
          console.log(rowData);
        } else {
          setRowData([]);
          toast.info("Record Not Found");
        }
      })
      .catch((error: any) => {
        toast.error(error.message);
        setIsStatusDone(false);
      });
  };

  const cancelPaypal = async () => {
    setIsCancelDone(true);
    await axiosInterceptorInstance
      .post(
        `/dashboard/PaypalCancellation?SubscriptionId=${subscriptionId.trim()}&Reason=${cancellationReason.trim()}`
      )
      .then((res: any) => {
        setAction(false);
        setIsCancelDone(false);
        const apiresponse = res.data;
        setCancellationReason("");
        if (apiresponse.message == "Failture") {
          toast.error("Already done or Invalid ID.");
        }
        if (apiresponse.message == "Success") {
          toast.info("Cancel Successfully done");
        }
      })
      .catch((error: any) => {
        setAction(false);
        setIsCancelDone(false);
        setCancellationReason("");
        toast.error(error.message);
      });
  };
  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };

  const ActionsCellRenderer: React.FC<{ data: any }> = ({ data }) => {
    return (
      <Button
        onClick={() => {
          setAction(true);
        }}
        className="dButton dButton2"
        variant="contained"
        style={{ height: "32px", textTransform: "none" }}
        disabled={data.PaypalStatus != "ACTIVE"}
      >
        Cancel
      </Button>
    );
  };

  const columnDefs: ColDef[] = [
    {
      field: "SubscriptionId",
      headerName: "SubscriptionId",
      resizable: true,
    },
    {
      field: "MSISDN",
      headerName: "MSISDN",
      resizable: true,
    },
    {
      field: "PaypalStatus",
      headerName: "PaypalStatus",
      resizable: true,
    },
    { headerName: "Action", cellRenderer: ActionsCellRenderer },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Paypal Cancellation</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                className="formControl"
                label="SubscriptionId"
                variant="outlined"
                defaultValue={subscriptionId}
                onChange={(e) => setSubscriptionId(e.target.value)}
                inputProps={{ maxLength: 200 }}
              />
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={() => handlePaypalStatus()}
                className="dButton dButton2"
                variant="contained"
                disabled={isStatusDone == true}
              >
                Search
              </Button>
            </Grid>
          </Grid>
          {isStatusDone && (
            <div className="circular-loader" style={{ marginLeft: "0px" }}>
              <CircularProgress size={40} />
            </div>
          )}
        </div>
      </div>
      {rowData.length > 0 && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={rowData}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
            onGridReady={onGridReady}
          ></AgGridReact>
        </div>
      )}

      <Dialog
        open={action}
        onClose={() => {
          setAction(false), setCancellationReason("");
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Reason for Cancellation"}
        </DialogTitle>

        <TextField
          className="formControl"
          label="Reason"
          variant="outlined"
          value={cancellationReason}
          onChange={(e) => setCancellationReason(e.target.value)}
        />

        <DialogActions>
          {cancellationReason.trim() && (
            <>
              <Button
                variant="contained"
                className="dButton dButton2 dbuttonSec"
                onClick={() => {
                  setAction(false), setCancellationReason("");
                }}
              >
                Dismiss
              </Button>
              <div style={{ width: "30px" }}></div>
              {!isCancelDone ? (
                <Button
                  variant="contained"
                  className="dButton dButton2"
                  onClick={() => handleCancelPaypal()}
                >
                  Submit
                </Button>
              ) : (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </motion.div>
  );
};

export default PaypalCancellation;
